import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  photo,
  applicant_type,
  applicant_name,
  verifiiedClass,
  container,
  statementContainer,
  statementContainerMoreData,
  eclipseEffect,
  statement_shadow
} from './UploadBankStatements.module.css';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import VrifiedBadge from '../../../assets/bankStatement/verified_badge.svg';
import SvgComponent from '../SvgComponent/SvgComponent';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import ResiizeObserver from '../../../common/components/ResizeObserver/ResizeObserver';
import { getLeadBankStatements } from '../../constants/api';
import PopUp from '../PopUp/PopUp';
import { navigate } from 'gatsby';
const UploadedBankStatement = ({ leadId }) => {
  const [gridblocks, setGridBlocks] = useState(1);
  const containerRef = useRef();

  const [statementsData, setStatementsData] = useState([]);

  const [showPopUp, setShowPopup] = useState(false);
  const [popUpData, setPopUpData] = useState({
    type: 'loading',
    text: 'Fetching the files, Please wait...',
    dontClose: false
  });

  const getData = async () => {
    setPopUpData({
      type: 'loading',
      text: 'Fetching the files, Please wait...',
      dontClose: false
    });
    setShowPopup(true);
    try {
      let data = await getLeadBankStatements({ leadId });
      setStatementsData(data);
    } catch {
      setStatementsData([]);
    } finally {
      setShowPopup(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const getName = name => {
    let rawName = name;
    try {
      rawName = rawName?.replace(/_/g, ' ');
      return rawName;
    } catch (e) {
      return name;
    }
  };
  const StatememtBlock = ({ each, applicantId }) => {
    return (
      <div
        className={`w-full mt-4 px-2 flex shadow py-3 px-2 ${statement_shadow}`}
      >
        <div
          className="w-full cursor-pointer"
          onClick={() => {
            navigate(
              `/app/applicant/bank-statement/${leadId}/${applicantId}/${each?.docId}`
            );
          }}
        >
          <div className="w-full flex  items-center ">
            <FontAwesomeIcon
              icon={faFilePdf}
              className="text-red-mandy h-5 "
              style={{ width: '1rem' }}
            />
            <p
              className={`font-barlow-medium text-sm ml-2 text-black-400 capitalize ${eclipseEffect}`}
              style={{ maxWidth: '160px' }}
            >
              {getName(each?.docName) || ''}
            </p>
          </div>
          <p className="font-barlow-medium text-sm text-black-400"></p>
        </div>
        <div className="table float-right">
          <SmsOutlinedIcon className="text-black-400" />
        </div>
      </div>
    );
  };

  const BankStatemets = ({ statements, applicantId }) => {
    const [showMoredata, setShowMoreData] = useState(false);
    const bankStatements = typeof statements == 'object' ? statements : [];
    return (
      <div className={`w-full `}>
        <div
          className="bg-green-tiber px-2 py-1 rounded grid grid-cols-2"
          style={{ height: '30px' }}
        >
          <div className="w-full text-white">
            <p className="font-barlow-medium text-white text-left text-sm"></p>
          </div>
          <div className="w-full text-blue-powderBlue text-right">
            <p className="font-barlow-medium text-blue-powderBlue text-right"></p>
          </div>
        </div>
        <div
          className={`${
            showMoredata ? statementContainerMoreData : statementContainer
          }`}
        >
          {bankStatements?.length == 0 && (
            <p className="text-black-400 text-center mt-5 mb-3 text-sm font-barlow">
              No bank statement found!
            </p>
          )}
          {bankStatements?.map((each, index) => (
            <div
              className={`w-full ${!showMoredata && index != 0 && 'hidden'}`}
            >
              <StatememtBlock each={each} applicantId={applicantId} />
            </div>
          ))}
          {!showMoredata && bankStatements?.length > 1 && (
            <div
              className="text-green-tiber100 font-barlow-bold text-sm mt-3 w-full text-center cursor-pointer"
              onClick={() => setShowMoreData(true)}
            >
              {`+ ${bankStatements?.length - 1} More`}
            </div>
          )}
        </div>
      </div>
    );
  };
  const handleCallBack = () => {
    setGridBlocks(parseInt(containerRef?.current?.clientWidth / 260 || 1));
  };
  return (
    <div className="w-full table">
      <p className="font-barlow-bold text-lg pt-4  text-green-tiber">
        Bank Statement
      </p>
      <ResiizeObserver
        targetNodeRef={containerRef}
        handleCallBack={handleCallBack}
      >
        <div
          className={`w-full grid grid-cols-${gridblocks} justify-around mt-5 overflow-hidden`}
        >
          {statementsData.map((each, index) => {
            return (
              <div
                className={` py-3 px-3 border border-skyBlue-linkWater  my-2 rounded ${
                  gridblocks == 1 ? 'w-11/12 mr-auto' : container
                }`}
                style={{ height: 'fit-content' }}
                key={index}
              >
                <div className="flex w-full">
                  <span className={`-mt-1`}>
                    <AccountBoxIcon className={photo} />
                  </span>
                  <span className={`block px-2 `}>
                    <p
                      className={`font-barlow-bold text-black-1011 text-base ${applicant_name}`}
                    >
                      {`${each?.personName?.firstName || ''} ${each?.personName
                        ?.middleName || ''} ${each?.personName?.lastName ||
                        ''}`}
                    </p>
                    <p
                      className={`font-barlow text-black-600 text-sm ${applicant_type}`}
                    >
                      {index == 0 ? 'Applicant' : `Applicant ${index}`}
                    </p>
                  </span>
                  <span>
                    <SvgComponent
                      img={VrifiedBadge}
                      className={`text-green-mountainMeadow ${verifiiedClass}`}
                    />
                  </span>
                </div>
                <hr className="text-blue-perano w-full my-3" />
                <div className="w-full">
                  {each?.bankStatementDetails && (
                    <BankStatemets
                      statements={each?.bankStatementDetails || []}
                      applicantId={each?.applicantId}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </ResiizeObserver>
      <PopUp
        dontClose={popUpData.dontClose}
        type={popUpData.type}
        text={popUpData.text}
        show={showPopUp}
        setShow={setShowPopup}
      />
    </div>
  );
};
export default UploadedBankStatement;
